import React from "react";

import PropTypes from "prop-types";
import IconButton from "components/IconButton";
import Field from "containers/Field";
import PageTitleUrl from "./PageTitleUrl";
import PageActiveStatus from "playground/cms/views/Pages/PageForm/PageActiveStatus";
import Button from "components/Button";
import Icon from "components/Icon";
import { usePageUrl } from "../../../state/hooks";

const taggable = [
    "cms.entries.offers",
    "cms.entries.rooms",
    "cms.entries.posts",
    "cms.entries.reviews",
    "cms.entries.attractions",
    "cms.products",
    "cms.categories",
];
const linkable = [
    "cms.pages",
    "cms.entries.offers",
    "cms.entries.rooms",
    "cms.entries.posts",
    "cms.entries.attractions",
    "cms.products",
    "cms.categories",
];
const titles = {
    "cms.pages": "title",
    "cms.layouts": "description",
    "cms.entries.offers": "title",
    default: "title",
};

const titleLabels = {
    "cms.entries.offers": "Nazwa oferty",
    "cms.entries.contacts": "Nazwa kontaktu",
    "cms.layouts": "Nazwa szablonu",
    default: "Tytuł",
};

export default function PageFormHeader(props) {
    const { onOpenPreview, onClose, type, id, isPageType } = props;
    const { children, ...other } = props;

    const url = usePageUrl(props.type, props.id);
    const open = () => window.open(`${url.host}/${url.slug}`);

    return (
        <div className={"page-form-header rows gap-sm"}>
            <PageActiveStatus {...other} />
            <div className={"cols cols-middle default-c500"}>
                <div className={"grow"}>
                    <PageTitleUrl
                        {...other}
                        isPage={isPageType}
                        titlePlaceholder={
                            titleLabels[type] || titleLabels.default
                        }
                    />
                </div>
                <div className={"cols cols-middle gap-md"}>
                    {isPageType && (
                        <IconButton
                            icon={"mui-open_in_new"}
                            title={"Otwórz w nowej karcie"}
                            onClick={open}
                        />
                    )}
                    {onOpenPreview ? (
                        <>
                            <Button
                                onClick={() => onOpenPreview("designer")}
                                size={"small"}
                                variant={"outlined"}
                                color={"default"}
                                startIcon={<Icon>mui-format_shapes</Icon>}
                            >
                                Podgląd
                            </Button>
                        </>
                    ) : null}
                    {onClose ? (
                        <IconButton icon={"mui-close"} onClick={onClose} />
                    ) : null}
                    {/*<IconButton icon={'mui-more_vert'} />*/}
                </div>
            </div>
            {/*{taggable.includes(type) && (*/}
            {/*    <Field*/}
            {/*        key={`tags-${id}`}*/}
            {/*        id={"tags"}*/}
            {/*        fieldType={"select"}*/}
            {/*        source={"api:tags"}*/}
            {/*        label={"Tagi"}*/}
            {/*        nullable={true}*/}
            {/*        multiple={true}*/}
            {/*        taggable={true}*/}
            {/*        variant={"inline"}*/}
            {/*    />*/}
            {/*)}*/}
            {children}
        </div>
    );
}

PageFormHeader.propTypes = {
    onOpenPreview: PropTypes.func,
};
